// src/components/UI/LoadingOverlay.js
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './LoadingOverlay.module.css';
import EcomBuddhaLogoIcon from '../../assets/icons/buddha.png';

const LoadingOverlay = () => {
  const content = (
    <div className={styles.loadingOverlay} aria-live="assertive" role="alert">
      <div className={styles.loadingContent}>

        {/* --- Use the imported Icon component --- */}
        <img src={EcomBuddhaLogoIcon} className={styles.loadingLogo} alt="Loading" />
        {/* --- End Icon usage --- */}

        {/* Animated Text */}
        <p className={styles.loadingText}>
          Processing
          <span className={styles.dot1}>.</span>
          <span className={styles.dot2}>.</span>
          <span className={styles.dot3}>.</span>
        </p>
      </div>
    </div>
  );
  return typeof document !== 'undefined'
    ? ReactDOM.createPortal(content, document.body)
    : content;
};

export default LoadingOverlay;